import { render, staticRenderFns } from "./Parks.vue?vue&type=template&id=38209a8a&scoped=true&"
import script from "./Parks.vue?vue&type=script&lang=js&"
export * from "./Parks.vue?vue&type=script&lang=js&"
import style0 from "./Parks.vue?vue&type=style&index=0&id=38209a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38209a8a",
  null
  
)

export default component.exports